import { render } from "./UploadComponent.vue?vue&type=template&id=252c5445&scoped=true"
import script from "./UploadComponent.vue?vue&type=script&lang=js"
export * from "./UploadComponent.vue?vue&type=script&lang=js"

import "./UploadComponent.vue?vue&type=style&index=0&id=252c5445&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252c5445"]])

export default __exports__